// src/antdviews/components/account.detail/AccountInfoTab.tsx

import React from 'react'
import { Card, Table, Avatar, Row, Col } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import type { ColumnsType } from 'antd/es/table'

interface PhoneInfo {
    phoneMode: string
    phoneManufacturer: string
    phoneVersion: string
    phoneSDK: string
    hasPhoneMode: boolean
    hasPhoneManufacturer: boolean
    hasPhoneVersion: boolean
    hasPhoneSDK: boolean
}

interface UserItem {
    user_id: string
    name: string
    middleName?: string
    lastName?: string
    gender: number
    genderStr: string
    age: number
    birthday: string
    created: string
    online_portrait?: string
    yearBirth?: number
    monthBirth?: number
    dayBirth?: number
}

interface RecordItem {
    url: string
    fileName: string
    nickname: string
    device: string
    size: string
    startTime: string
    timeLength: string
    sourceStr: string
    description?: string
    href: string
    reports: Array<{ name: string; type: number }>
    decodeProgress: number
    rate: number
    meta: any
    location: number
    source: number
    reportTypes: number
}

interface LogItem {
    id: string
    date: string
    size: string
    updateTime: string
    source: number
    filePath: string
    fileName: string
    uuid: string
    rowspan: number
    hideDate?: boolean
}

interface DetailData {
    isActive: boolean
    accountName: string
    accountEmail: string
    onlinePortrait: string | null
    users: { list: UserItem[]; totalPages?: number; currentPage?: number; totalRecords?: number; pages?: number[] }
    logs: { list: LogItem[]; totalPages?: number; currentPage?: number; totalRecords?: number; pages?: number[] }
    records: { list: RecordItem[]; totalPages?: number; currentPage?: number; totalRecords?: number; pages?: number[] }
    phoneInfo: PhoneInfo
}

interface AccountInfoTabProps {
    detail: DetailData
    trans: (key: string) => string
}

export default class AccountInfoTab extends React.Component<AccountInfoTabProps> {

    getPortrait(item: UserItem) {
        if (item.online_portrait) {
            return <Avatar src={item.online_portrait} size="default" />
        }
        return <Avatar icon={<UserOutlined />} size="default" />
    }

    getActive() {
        const { detail } = this.props
        const bgColor = detail.isActive ? 'bg-success' : 'bg-primary'
        if (detail.onlinePortrait) {
            return (
                <div className="summary-icon">
                    <img
                        className="portrait-card"
                        src={detail.onlinePortrait}
                        alt="头像"
                        style={{
                            width: 80,
                            height: 80,
                            objectFit: 'cover',
                        }}
                    />
                </div>
            )
        }
        return (
            <div className={`summary-icon ${bgColor}`}>
                <i className="fa fa-user"></i>
            </div>
        )
    }

    render() {
        const { detail, trans } = this.props

        // 用户表格列定义
        const userColumns: ColumnsType<UserItem> = [
            {
                title: trans('portrait'),
                key: 'portrait',
                render: (_, record) => this.getPortrait(record),
            },
            {
                title: trans('userId'),
                dataIndex: 'user_id',
                key: 'user_id',
            },
            {
                title: trans('nickname'),
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: trans('birthday'),
                dataIndex: 'birthday',
                key: 'birthday',
            },
            {
                title: trans('gender'),
                dataIndex: 'genderStr',
                key: 'genderStr',
            },
            {
                title: trans('age'),
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: trans('createTime'),
                dataIndex: 'created',
                key: 'created',
            },
        ]

        return (
            <div>
                <Row gutter={16}>
                    {/** 账号基本信息 */}
                    <Col xs={24} sm={24} md={8} lg={6} xl={5}>
                        <Card>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                {/** 头像 */}
                                <div style={{ marginBottom: 12 }}>
                                    {this.getActive()}
                                </div>
                                {/** 邮箱 */}
                                <h4 className="title" style={{ marginBottom: 4, wordBreak: 'break-all' }}>
                                    {detail.accountEmail}
                                </h4>
                                {/** 昵称 */}
                                <div className="info" style={{ marginBottom: 12 }}>
                                    <strong className="amount">{detail.accountName}</strong>
                                    <span style={{ color: 'red' }}>{detail.isActive ? `(${trans('active')})` : ''}</span>
                                </div>
                                {/** 设备信息 */}
                                <div className="summary-footer" style={{ width: '100%' }}>
                                    <div className="text-muted" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span>{trans('phoneMode')}</span>
                                        <span>{detail.phoneInfo.phoneMode}</span>
                                    </div>
                                    <div className="text-muted" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span>{trans('phoneManufacturer')}</span>
                                        <span>{detail.phoneInfo.phoneManufacturer}</span>
                                    </div>
                                    <div className="text-muted" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span>{trans('phoneVersion')}</span>
                                        <span>{detail.phoneInfo.phoneVersion}</span>
                                    </div>
                                    <div className="text-muted" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span>{trans('phoneSDK')}</span>
                                        <span>{detail.phoneInfo.phoneSDK}</span>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Col>

                    {/** 使用者列表 */}
                    <Col xs={24} sm={24} md={16} lg={18} xl={19}>
                        <Card title={trans('userList')}>
                            <Table
                                dataSource={detail.users.list}
                                rowKey={(record) => record.user_id}
                                pagination={false}
                                size="small"
                                columns={userColumns}
                            />
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}